"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6481],{

/***/ 79592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16423);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: initial;\n  border: none;\n  text-decoration: none;\n  &:focus {\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Link = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_1___default()))(_templateObject(), (param)=>{
    let { theme , $origin , $textSecondary , $error , $nowrap , $color , href  } = param;
    return "\n    color: ".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([
        [
            (props)=>props.$error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.$origin,
            ()=>theme.palette.text.primary
        ],
        [
            (props)=>props.$textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            ()=>true,
            ()=>theme.palette.primary.main
        ]
    ])({
        $origin,
        $textSecondary,
        $error,
        $color
    }), ";\n    white-space: ").concat($nowrap ? "nowrap" : "normal", ";\n    cursor: ").concat(href !== "" ? "pointer" : "default", ";\n\n    &:hover {\n      color: ").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([
        [
            (props)=>props.$error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.$origin,
            ()=>theme.palette.text.primary
        ],
        [
            (props)=>props.$textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            ()=>true,
            ()=>theme.palette.primary.main
        ]
    ])({
        $origin,
        $textSecondary,
        $error,
        $color
    }), ";\n    }\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 58635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79697);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29630);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77366);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79592);
/* harmony import */ var components_common_Hidden__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18450);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: url('/img/img_headshot_default.png');\n  background-size: 100%;\n  background-position: center;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}










const ImgRect = _emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { theme , $usedInVenderPage  } = param;
    return "\n    position: relative;\n    padding-top: 100%;\n\n    ".concat(theme.breakpoints.up($usedInVenderPage ? "md" : "lg"), " {\n      padding-top: 75%;\n    }\n  ");
});
const Absolute = _emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(_templateObject1());
const Img = _emotion_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img */ .Z.img(_templateObject2());
const getLinkFilterByTag = (tagUrlId, extraRouteParams)=>{
    const params = {
        ...extraRouteParams,
        tag: tagUrlId
    };
    return "/album?".concat((0,qs__WEBPACK_IMPORTED_MODULE_5__.stringify)(params));
};
const Album = (param)=>{
    let { album , onClick , onAlbumTagClick , extraRouteParams , usedInVenderPage  } = param;
    var _album_urlId, _album_urlId_toLowerCase;
    const photo = (album === null || album === void 0 ? void 0 : album.representativePhotoInfo) || (album === null || album === void 0 ? void 0 : album.frontCover);
    const image = photo === null || photo === void 0 ? void 0 : photo.image;
    const tags = photo === null || photo === void 0 ? void 0 : photo.tags;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const albumLink = "/album/".concat((_album_urlId = album.urlId) === null || _album_urlId === void 0 ? void 0 : (_album_urlId_toLowerCase = _album_urlId.toLowerCase) === null || _album_urlId_toLowerCase === void 0 ? void 0 : _album_urlId_toLowerCase.call(_album_urlId)) + ((0,lodash_es__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(extraRouteParams) ? "" : "?".concat((0,qs__WEBPACK_IMPORTED_MODULE_5__.stringify)(extraRouteParams)));
    const onAlbumClick = (e)=>{
        if (onClick) {
            onClick(e, album);
        } else {
            router.push(albumLink);
        }
    };
    const onTagClick = (e, tag)=>{
        e.preventDefault();
        e.stopPropagation();
        if (onAlbumTagClick) {
            onAlbumTagClick(tag);
        } else {
            router.push(getLinkFilterByTag(tag.urlId, extraRouteParams));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        display: "flex",
        flexDirection: "column",
        mb: 0,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_common_A__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                $origin: true,
                href: albumLink,
                onClick: onAlbumClick,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImgRect, {
                            $usedInVenderPage: usedInVenderPage,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Absolute, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
                                    src: image === null || image === void 0 ? void 0 : image.url,
                                    alt: album.name
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            fontWeight: "fontWeightBold",
                            mt: 3,
                            children: album.name
                        })
                    })
                ]
            }),
            !!(tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                mt: 2,
                sx: {
                    display: {
                        xs: "none",
                        ...usedInVenderPage ? {
                            md: "block"
                        } : {
                            lg: "block"
                        }
                    }
                },
                children: tags === null || tags === void 0 ? void 0 : tags.map((tag, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                        children: [
                            index > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                mx: 2.5,
                                component: "span",
                                color: "text.secondary",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                $textSecondary: true,
                                $nowrap: true,
                                href: getLinkFilterByTag(tag.urlId, extraRouteParams),
                                onClick: (e)=>onTagClick(e, tag),
                                children: tag.name
                            })
                        ]
                    }, tag.urlId))
            })
        ]
    });
};
Album.defaultProps = {
    extraRouteParams: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (Album);


/***/ }),

/***/ 18450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ HideInDesktopGrid; },
/* harmony export */   "W": function() { return /* binding */ HideInMobileGrid; },
/* harmony export */   "aI": function() { return /* binding */ HideInDesktopBox; },
/* harmony export */   "dz": function() { return /* binding */ HideInMobileBox; }
/* harmony export */ });
/* unused harmony exports withHideInMobile, withHideInDesktop */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79072);



const withHideInMobile = (WrappedComponent)=>{
    return (param)=>{
        let { display ="block" , sx ={} , component , ...props } = param;
        const finalDisplay = props.display === "flex" ? "flex" : component === "span" ? "inline-block" : display;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            sx: {
                display: {
                    xs: "none",
                    lg: finalDisplay
                },
                ...sx
            },
            ...props
        });
    };
};
const withHideInDesktop = (WrappedComponent)=>{
    return (param)=>{
        let { display ="block" , sx ={} , component , ...props } = param;
        const finalDisplay = props.display === "flex" ? "flex" : component === "span" ? "inline-block" : display;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            sx: {
                display: {
                    xs: finalDisplay,
                    lg: "none"
                },
                ...sx
            },
            ...props
        });
    };
};
const HideInMobileBox = withHideInMobile(_mui_material_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
const HideInDesktopBox = withHideInDesktop(_mui_material_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
const HideInMobileGrid = withHideInMobile(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);
const HideInDesktopGrid = withHideInDesktop(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);


/***/ }),

/***/ 37524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N1": function() { return /* binding */ ScrollableBox; },
/* harmony export */   "OW": function() { return /* binding */ FullscreenModal; },
/* harmony export */   "nv": function() { return /* binding */ InfoModal; },
/* harmony export */   "rK": function() { return /* binding */ FunctionModal; },
/* harmony export */   "tn": function() { return /* binding */ UserDataModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39477);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25425);
/* harmony import */ var _mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9942);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58735);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  overflow-y: auto;\n  scrollbar-width: none;\n  border: none;\n  outline: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  @media screen and (min-width: 992px) {\n    width: 540px;\n    height: initial;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}







const functionModalBackdropProps = {
    timeout: 500
};
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $autoHeight  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n\n    @media screen and (min-width: 992px) {\n      margin-top: 20px;\n      width: 540px;\n      height: ").concat($autoHeight ? "auto" : "737px", ";\n      border-radius: 10px;\n    }\n  ");
});
const ScrollableBox = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1());
// fullscreen in mobile devices
const FunctionModal = (param)=>{
    let { open , onClose , children , autoHeight , ModalWrapper , ...rest } = param;
    const UsedWrapper = ModalWrapper || Wrapper;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            direction: "up",
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UsedWrapper, {
                    onClick: (e)=>e.stopPropagation(),
                    $autoHeight: autoHeight,
                    children: children
                })
            })
        })
    });
};
const Fullscreen = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2(), (param)=>{
    let { theme , $autoHeight  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 100%;\n    height: ").concat($autoHeight ? "auto" : "100%", ";\n    min-height: ").concat($autoHeight ? "100vh" : "auto", ";\n    margin: 0 auto;\n  ");
});
// fullscreen in any devices
const FullscreenModal = (param)=>{
    let { open , onClose , children , autoHeight , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            direction: "up",
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Fullscreen, {
                    onClick: (e)=>e.stopPropagation(),
                    $autoHeight: autoHeight,
                    children: children
                })
            })
        })
    });
};
const InfoWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: calc(100% - 60px);\n    max-width: 540px;\n    height: initial;\n    margin: 0 auto;\n    border-radius: 10px;\n  ");
});
const UserDataWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject4(), (param)=>{
    let { theme  } = param;
    return "\n    overflow: hidden;\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 354px;\n    height: initial;\n    margin: 0 auto;\n    font-size: 16px;\n    border-radius: 12px;\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);\n  ");
});
// regular modal even in mobile devices
const InfoModal = (param)=>{
    let { open , onClose , children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    pt: "150px",
                    pb: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InfoWrapper, {
                        onClick: (e)=>e.stopPropagation(),
                        children: children
                    })
                })
            })
        })
    });
};
// user data modal
const UserDataModal = (param)=>{
    let { open , onClose , children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    pt: "150px",
                    pb: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UserDataWrapper, {
                        onClick: (e)=>e.stopPropagation(),
                        children: children
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 2925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  ",
        ";\n  line-height: ",
        ";\n  height: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const NowrapDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { $lines  } = param;
    return !!$lines && $lines > 1 ? "display: -webkit-box;" + "-webkit-line-clamp: ".concat($lines, ";") + "-webkit-box-orient: vertical;" : "white-space: nowrap;";
}, (param)=>{
    let { $fixHeight  } = param;
    return $fixHeight ? "1.2em" : "";
}, (param)=>{
    let { $lines , $fixHeight  } = param;
    return $fixHeight ? ($lines || 1) * 1.2 + "em" : "auto";
}, (param)=>{
    let { $textCenter  } = param;
    return $textCenter ? "center" : "left";
});
/* harmony default export */ __webpack_exports__["Z"] = (NowrapDiv);


/***/ }),

/***/ 92890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79072);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61303);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20625);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79592);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36406);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69854);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}






const Button = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { theme , $checked  } = param;
    return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    width: 32px;\n    height: 29px;\n    color: ".concat($checked ? "white" : theme.palette.text.secondary, ";\n    background-color: ").concat($checked ? theme.palette.primary.main : "white", ";\n    border-radius: ").concat(theme.spacing(1), ";\n    border: 1px solid ").concat($checked ? theme.palette.primary.main : "white", ";\n\n    &:hover {\n      border-color: ").concat(theme.palette.text.secondary, ";\n    }\n  ");
});
const Pagination = (param)=>{
    let { page , setPage , pageAmount , urlPath  } = param;
    let startPage = (0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
        [
            (p)=>p === 1,
            ()=>1
        ],
        [
            (p)=>p === 2 || p === 3,
            ()=>2
        ],
        [
            (p)=>p > 3,
            (p)=>p + 2 > pageAmount ? (0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
                    pageAmount - 4,
                    1
                ]) : p - 2
        ],
        [
            ()=>true,
            ()=>1
        ]
    ])(page);
    const length = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([
        5,
        pageAmount - startPage + 1
    ]);
    const paginations = Array.from({
        length
    }, (_, i)=>i + startPage);
    const onPrevClick = ()=>setPage((0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
            page - 1,
            1
        ]));
    const onNextClick = ()=>setPage((0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([
            page + 1,
            pageAmount
        ]));
    const abortLinkClick = (e)=>e.preventDefault();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            container: true,
            spacing: 1,
            children: [
                page !== 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                onClick: abortLinkClick,
                                href: !!urlPath ? "".concat(urlPath, "?page=").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
                                    page - 1,
                                    1
                                ])) : "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                                    onClick: onPrevClick,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__/* .ArrowLeft */ .X, {
                                        textSecondary: true
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                onClick: abortLinkClick,
                                href: !!urlPath ? "".concat(urlPath, "?page=1") : "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                                    onClick: ()=>setPage(1),
                                    children: "1"
                                })
                            })
                        })
                    ]
                }),
                paginations === null || paginations === void 0 ? void 0 : paginations.map((pagination)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            onClick: abortLinkClick,
                            href: !!urlPath ? "".concat(urlPath, "?page=").concat(pagination) : "",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                                $checked: page === pagination,
                                onClick: ()=>setPage(pagination),
                                children: pagination
                            })
                        })
                    }, "page-".concat(pagination))),
                page < pageAmount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        onClick: abortLinkClick,
                        href: !!urlPath ? "".concat(urlPath, "?page=").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([
                            page + 1,
                            pageAmount
                        ])) : "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                            onClick: onNextClick,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_9__/* .ArrowRight */ .o, {
                                textSecondary: true
                            })
                        })
                    })
                })
            ]
        })
    });
};
Pagination.defaultProps = {
    page: 1,
    pageAmount: 1
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 54996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98700);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const ResponsiveDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), _mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveDiv);


/***/ }),

/***/ 36406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ArrowLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ArrowLeft = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/sv g",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "arrow_left_24",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M15.707 5.293a1 1 0 010 1.414L10.414 12l5.293 5.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z",
                className: "Vector (Stroke)",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 69854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ArrowRight = (param)=>{
    let { color , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        $color: color,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "arrow_right_24l",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M8.293 5.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L13.586 12 8.293 6.707a1 1 0 010-1.414z",
                className: "Vector (Stroke)",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 47624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ FacebookIconSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const FacebookIconSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            className: "ic_share_facebook",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "20",
                    cy: "20",
                    r: "20",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 9.982 7.314 18.257 16.875 19.757V25.781h-5.078V20h5.078v-4.406c0-5.013 2.986-7.781 7.554-7.781 2.189 0 4.477.39 4.477.39v4.922h-2.522c-2.484 0-3.259 1.542-3.259 3.123V20h5.547l-.887 5.781h-4.66v13.976C32.686 38.257 40 29.983 40 20Z",
                    className: "Vector"
                })
            ]
        })
    });
};


/***/ }),

/***/ 52915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ LineCircleSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const LineCircleSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "Logo_Line",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                className: "LINE_LOGO",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    className: "Group",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#4CC764",
                            d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
                            className: "Vector"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            className: "Group",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fill: "#fff",
                                    d: "M20.003 11.301c0-3.585-3.595-6.501-8.011-6.501-4.417 0-8.011 2.917-8.011 6.501 0 3.214 2.85 5.905 6.7 6.414.26.056.616.172.706.395.08.203.052.52.026.725l-.114.685c-.035.203-.162.792.694.432.854-.36 4.613-2.716 6.293-4.65 1.162-1.274 1.718-2.566 1.718-4l-.002-.001Z",
                                    className: "Vector"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    className: "Group",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "#4CC764",
                                        d: "M17.338 13.371a.153.153 0 0 0 .153-.153v-.568a.154.154 0 0 0-.153-.153h-1.53v-.59h1.53a.153.153 0 0 0 .153-.154v-.567a.154.154 0 0 0-.153-.153h-1.53v-.59h1.53a.153.153 0 0 0 .153-.154v-.567a.154.154 0 0 0-.153-.153h-2.251a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h2.25Zm-8.325 0a.153.153 0 0 0 .153-.153v-.568a.154.154 0 0 0-.153-.153h-1.53V9.722a.154.154 0 0 0-.152-.153h-.569a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h2.25Zm1.354-3.802H9.8a.153.153 0 0 0-.153.153v3.495c0 .085.069.153.153.153h.568a.153.153 0 0 0 .153-.153V9.722a.153.153 0 0 0-.153-.153Zm3.868 0h-.569a.153.153 0 0 0-.152.153v2.076l-1.6-2.16-.012-.015H11.9a.03.03 0 0 0-.009-.01l-.003-.003-.008-.007c-.002 0-.003-.002-.005-.003l-.008-.005c-.002 0-.003-.002-.005-.003l-.008-.005-.004-.002-.01-.004-.005-.001-.008-.003c-.002 0-.004 0-.006-.002l-.009-.002h-.007l-.008-.001h-.578a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h.569a.153.153 0 0 0 .152-.153v-2.076l1.602 2.163a.147.147 0 0 0 .04.038l.001.002.01.006.004.002.008.004.007.003.005.001a.057.057 0 0 0 .01.003h.002a.144.144 0 0 0 .04.006h.565a.153.153 0 0 0 .153-.153V9.724a.153.153 0 0 0-.153-.153v-.002Z",
                                        className: "Vector"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 54806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16423);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46338);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const SVG = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].svg */ .Z.svg(_templateObject(), (param)=>{
    let { theme , primary , error , white , textSecondary , $ptr , $color  } = param;
    return "\n    fill: ".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([
        [
            (props)=>props.error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.primary,
            ()=>theme.palette.primary.main
        ],
        [
            (props)=>props.white,
            ()=>theme.palette.primary.contrastText
        ],
        [
            (props)=>props.textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            ()=>theme.palette.text.primary
        ]
    ])({
        primary,
        error,
        white,
        textSecondary,
        $color
    }), ";\n    ").concat($ptr ? "cursor: pointer;" : "", "\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (SVG);


/***/ }),

/***/ 98780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var _mui_icons_material_ExpandLess__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60181);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const ScrollButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    position: fixed;\n    bottom: 100px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%);\n    background-color: ".concat(theme.palette.grey.third, ";\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    cursor: pointer;\n    color: ").concat(theme.palette.text.primary, ";\n    z-index: 98;\n\n    &:active {\n      background-color: ").concat(theme.palette.primary.bgPlus1, ";\n      border: 1px solid #ffffff;\n    }\n\n    > .muiIcon {\n      position: absolute;\n      top: 50%; \n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n  ");
});
const ScrollToTopButton = (param)=>{
    let { showButton , scrollableRef , isAutoScroll  } = param;
    const onScrollToTopClick = ()=>{
        setTimeout(()=>{
            var _scrollableRef_current;
            return scrollableRef.current && ((_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                top: 0,
                behavior: "smooth"
            }));
        }, 0);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isAutoScroll) {
            setTimeout(()=>{
                var _scrollableRef_current;
                return scrollableRef.current && ((_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                    top: 0,
                    behavior: "smooth"
                }));
            }, 0);
        }
    }, [
        isAutoScroll
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButton, {
        style: {
            display: showButton ? "inline" : "none"
        },
        onClick: onScrollToTopClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ExpandLess__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            fontSize: "large",
            className: "muiIcon"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollToTopButton);


/***/ }),

/***/ 28086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61953);
/* harmony import */ var utils_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13946);
/* harmony import */ var components_common_ResponsiveDiv__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54996);
/* harmony import */ var components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98780);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: auto;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n  height: 100%;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






const Scrollable = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
const ScrollableResponsiveDiv = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(components_common_ResponsiveDiv__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject1());
const ScrollableWrapper = (param)=>{
    let { children , responsive =false , onCopy =null , containerId =null , wrapperRef , isAutoScroll =false  } = param;
    const { showButton , showScrollButton  } = (0,utils_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useShowScrollToTopButton */ .zi)();
    return responsive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ScrollableResponsiveDiv, {
        onCopy: onCopy,
        ref: wrapperRef,
        onScroll: showScrollButton,
        id: containerId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                showButton: showButton,
                scrollableRef: wrapperRef,
                isAutoScroll: isAutoScroll
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Scrollable, {
        onCopy: onCopy,
        ref: wrapperRef,
        onScroll: showScrollButton,
        id: containerId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                showButton: showButton,
                scrollableRef: wrapperRef,
                isAutoScroll: isAutoScroll
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollableWrapper);


/***/ }),

/***/ 78327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46541);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23508);
/* harmony import */ var _mui_icons_material_ArrowDropDown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45111);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93021);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}






const StyledSelect = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Select__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , disabled , $hasSelection , $size , $color  } = param;
    return "\n    font-size: ".concat($size === "large" ? theme.typography.body1.fontSize : $size === "medium" ? "16px" : $size === "small" ? "14px" : theme.typography.h6.fontSize, ";\n\n    &::before, &::after {\n      border-bottom: none !important;\n    }\n\n    #selector {\n      padding-left: 10px;\n      &:focus {\n        background-color: initial;\n      }\n    }\n\n    #service-info {\n      ").concat(disabled ? "background-color: ".concat(theme.palette.background.gray) : "", ";\n    }\n\n    color: ").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
        [
            ()=>disabled && $hasSelection,
            ()=>theme.palette.text.minus2
        ],
        [
            ()=>disabled && !$hasSelection,
            ()=>theme.palette.text.secondary
        ],
        [
            ()=>$hasSelection,
            ()=>$color === "primary" ? theme.palette.primary.main : theme.palette.text.minus2
        ],
        [
            ()=>true,
            ()=>theme.palette.text.secondary
        ]
    ])(), ";\n    ").concat(disabled ? "background-color: ".concat(theme.palette.background.gray) : "", ';\n    div[role="button"] {\n      ').concat($size === "medium" ? "padding: 12px ".concat($hasSelection ? "32px" : "16px", " 12px 15px;") : "", "\n      ").concat($size === "small" ? "padding: 10px ".concat($hasSelection ? "32px" : "16px", " 10px 10px;") : "", "\n    }\n    ").concat($size === "medium" ? "#selector { padding: 12px ".concat($hasSelection ? "32px" : "16px", " 12px 15px; }") : "", "\n    ").concat($size === "small" ? "#selector { padding: 10px ".concat($hasSelection ? "32px" : "16px", " 10px 10px; }") : "", "\n  ");
});
const StyledExpandMoreIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    fill: ".concat(theme.palette.text.disabled, ";\n  ");
});
const MainTextExpandMoreIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    padding-right:8px;\n    fill: ".concat(theme.palette.text.primary, ";\n  ");
});
const StyledArrowDropDownIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_icons_material_ArrowDropDown__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    padding-right:8px;\n    fill: ".concat(theme.palette.text.disabled, ";\n  ");
});
const chooseIconByColor = function(color) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "medium";
    if (size === "small") {
        return StyledArrowDropDownIcon;
    }
    if (color === "textPrimary") {
        return MainTextExpandMoreIcon;
    }
    return StyledExpandMoreIcon;
};
const Select = (param)=>{
    let { label , value , onChange , disabled , IconComponent , size , color , iconColor , children , muiLabel , labelId , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSelect, {
        value: value,
        onChange: onChange,
        disabled: disabled,
        label: muiLabel,
        labelId: labelId,
        $hasSelection: !!value || value === 0 || value === false,
        $size: size,
        $color: color,
        ...rest,
        inputProps: {
            id: "selector"
        },
        IconComponent: IconComponent || chooseIconByColor(iconColor, size),
        children: [
            !!(rest === null || rest === void 0 ? void 0 : rest.native) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                value: "",
                disabled: true,
                children: label
            }),
            children
        ]
    });
};
Select.defaultProps = {
    native: true,
    value: "",
    size: "default",
    color: "primary"
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 69575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yw": function() { return /* binding */ DEFAULT_SORT; },
  "h8": function() { return /* binding */ NUMBER_PER_PAGE; },
  "ZP": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/lodash-es/intersection.js
var intersection = __webpack_require__(8961);
// EXTERNAL MODULE: ./node_modules/lodash-es/max.js + 1 modules
var max = __webpack_require__(61303);
// EXTERNAL MODULE: ./node_modules/lodash-es/flatten.js
var flatten = __webpack_require__(27961);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./utils/api/hooks/usePhotoClassifications.js
var usePhotoClassifications = __webpack_require__(57874);
// EXTERNAL MODULE: ./utils/api/hooks/useAlbums.js
var useAlbums = __webpack_require__(55108);
// EXTERNAL MODULE: ./utils/api/hooks/useAlbumCount.js
var useAlbumCount = __webpack_require__(61908);
// EXTERNAL MODULE: ./utils/api/hooks/useInfiniteAlbums.js
var useInfiniteAlbums = __webpack_require__(10920);
// EXTERNAL MODULE: ./utils/api/hooks/usePhotoTags.js
var usePhotoTags = __webpack_require__(82688);
// EXTERNAL MODULE: ./utils/hooks/index.js
var hooks = __webpack_require__(13946);
// EXTERNAL MODULE: ./utils/native-notifier.js
var native_notifier = __webpack_require__(11634);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(73221);
// EXTERNAL MODULE: ./components/common/Layout/index.js
var Layout = __webpack_require__(82023);
// EXTERNAL MODULE: ./components/common/Header/index.js + 2 modules
var Header = __webpack_require__(75883);
// EXTERNAL MODULE: ./components/common/Footer/index.js + 12 modules
var Footer = __webpack_require__(56007);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./components/common/NowrapDiv/index.js
var NowrapDiv = __webpack_require__(2925);
// EXTERNAL MODULE: ./components/common/Modal/index.js
var Modal = __webpack_require__(37524);
// EXTERNAL MODULE: ./components/common/AlbumListItem/index.js
var AlbumListItem = __webpack_require__(58635);
// EXTERNAL MODULE: ./components/common/Pagination/index.js
var Pagination = __webpack_require__(92890);
;// CONCATENATED MODULE: ./components/pages/Album/Index/TagList.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}






const StyledButton = (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z)(_templateObject(), (param)=>{
    let { theme , $selected  } = param;
    return "\n    &:hover {\n      background-color: ".concat(!$selected ? theme.palette.primary.bgPlus1 : "", ";\n    }\n  ");
});
const checkSelected = (target, filters)=>{
    return filters.some((filterUrlId)=>filterUrlId === target.urlId);
};
const TagList = (param)=>{
    let { category , filters , onChange , defaultCollapse  } = param;
    var _category_tags, _category_tags1;
    const [isCollapse, setCollapse] = (0,react.useState)(defaultCollapse && (category === null || category === void 0 ? void 0 : (_category_tags = category.tags) === null || _category_tags === void 0 ? void 0 : _category_tags.length) > 6);
    const onMoreClick = ()=>setCollapse(false);
    const onTagClick = (targetTag)=>{
        var _category_tags;
        const selectedTagInSameCategory = category === null || category === void 0 ? void 0 : (_category_tags = category.tags) === null || _category_tags === void 0 ? void 0 : _category_tags.find((tag)=>{
            return filters === null || filters === void 0 ? void 0 : filters.find((filterUrlId)=>filterUrlId === tag.urlId);
        });
        if ((selectedTagInSameCategory === null || selectedTagInSameCategory === void 0 ? void 0 : selectedTagInSameCategory.urlId) === targetTag.urlId) {
            onChange(filters.filter((filterUrlId)=>filterUrlId !== targetTag.urlId));
        } else {
            const newFilters = filters.filter((filterUrlId)=>{
                return filterUrlId !== (selectedTagInSameCategory === null || selectedTagInSameCategory === void 0 ? void 0 : selectedTagInSameCategory.urlId);
            }).concat([
                targetTag.urlId
            ]);
            onChange(newFilters);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        children: [
            category === null || category === void 0 ? void 0 : (_category_tags1 = category.tags) === null || _category_tags1 === void 0 ? void 0 : _category_tags1.map((tag, index)=>(index < 6 || !isCollapse) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        variant: "contained",
                        color: checkSelected(tag, filters) ? "primary" : "grey",
                        $selected: checkSelected(tag, filters),
                        fullWidth: true,
                        onClick: ()=>onTagClick(tag),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: tag.name
                        })
                    })
                }, tag._id)),
            isCollapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    fullWidth: true,
                    onClick: onMoreClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "更多",
                            category === null || category === void 0 ? void 0 : category.name
                        ]
                    })
                })
            })
        ]
    });
};
TagList.defaultProps = {
    defaultCollapse: true
};
/* harmony default export */ var Index_TagList = (TagList);

;// CONCATENATED MODULE: ./components/pages/Album/Index/FilterModal.js








const FilterModal = (param)=>{
    let { open , tagCategories , defaultFilters , onClose , onConfirm  } = param;
    const [filters, setFilters] = (0,react.useState)(defaultFilters || []);
    (0,react.useEffect)(()=>{
        if (open && filters !== defaultFilters) {
            setFilters(defaultFilters || []);
        }
    }, [
        open
    ]);
    const closeModal = ()=>{
        setFilters(defaultFilters || []);
        onClose();
    };
    const onConfirmClick = ()=>{
        onConfirm(filters);
        closeModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* FunctionModal */.rK, {
        open: open,
        onClose: onClose,
        autoHeight: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    flexGrow: 1,
                    px: 4,
                    py: 2,
                    overflow: "auto",
                    children: tagCategories === null || tagCategories === void 0 ? void 0 : tagCategories.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        fontWeight: "fontWeightBold",
                                        py: 6,
                                        children: category.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_TagList, {
                                    category: category,
                                    filters: filters,
                                    onChange: setFilters
                                })
                            ]
                        }, category._id))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    p: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        spacing: 3,
                        justifyContent: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 6,
                                lg: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "outlined",
                                    size: "small",
                                    fullWidth: true,
                                    onClick: closeModal,
                                    children: "取消"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 6,
                                lg: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    size: "small",
                                    variant: "contained",
                                    color: "primary",
                                    fullWidth: true,
                                    onClick: onConfirmClick,
                                    children: "確認"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
FilterModal.defaultProps = {
    defaultFilters: [],
    tagCategories: []
};
/* harmony default export */ var Index_FilterModal = (FilterModal);

;// CONCATENATED MODULE: ./components/pages/Album/Index/helpers.js

const getTagName = (tagCategories, tagUrlId)=>{
    const tagsList = (tagCategories || []).map((classification)=>classification.tags);
    const tag = (0,flatten/* default */.Z)(tagsList).find((tag)=>tag.urlId === tagUrlId);
    return (tag === null || tag === void 0 ? void 0 : tag.name) || "";
};
const getAllFiltersName = function(tagCategories) {
    let filters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return filters === null || filters === void 0 ? void 0 : filters.map((tagUrlId)=>getTagName(tagCategories, tagUrlId)).filter((name)=>name);
};
const getFiltersNameString = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    const names = getAllFiltersName(...args);
    return (names || []).join(", ");
};

;// CONCATENATED MODULE: ./components/pages/Album/Index/FiltersChangeModal.js






const FiltersChangeModal = (param)=>{
    let { open , onClose , onConfirm , originFilters , tag , tagCategories  } = param;
    const filterNames = getAllFiltersName(tagCategories, originFilters);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* InfoModal */.nv, {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    p: 5,
                    children: "是否更改篩選條件"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: 5,
                children: [
                    "是否要把篩選條件從",
                    filterNames === null || filterNames === void 0 ? void 0 : filterNames.map((name)=>"「".concat(name, "」")).join(""),
                    "改成篩選 「",
                    tag === null || tag === void 0 ? void 0 : tag.name,
                    "」 ？"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "flex-end",
                p: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mr: 2.5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            onClick: onClose,
                            size: "small",
                            children: "取消"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        size: "small",
                        variant: "contained",
                        color: "primary",
                        onClick: ()=>onConfirm(tag),
                        children: "確定"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Index_FiltersChangeModal = (FiltersChangeModal);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(55343);
// EXTERNAL MODULE: ./components/common/Select/index.js
var Select = __webpack_require__(78327);
;// CONCATENATED MODULE: ./components/pages/Album/Index/SortSelect.js





const SortSelect = (param)=>{
    let { value , onChange , color  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: "textSecondary",
                    children: "排序"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        minWidth: 110
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                        fullWidth: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                            size: "large",
                            color: color || "primary",
                            value: value,
                            onChange: onChange,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "-sort -createdTime",
                                    children: "推薦排序"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "-photoTotalViews",
                                    children: "熱門程度"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "-updateFieldsAtTime",
                                    children: "由新到舊"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Index_SortSelect = (SortSelect);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 3 modules
var MenuItem = __webpack_require__(90060);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
;// CONCATENATED MODULE: ./components/common/PopupSelect/index.js

function PopupSelect_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    PopupSelect_templateObject = function() {
        return data;
    };
    return data;
}









const PopupSelect_Modal = emotion_styled_browser_esm/* default.div */.Z.div(PopupSelect_templateObject(), (param)=>{
    let { theme , $top , $left , $right , $alignRight , $width , $maxHeight  } = param;
    return "\n    position: absolute;\n    top: ".concat($top, "px;\n    left: ").concat($left, "px;\n    right: ").concat($right, "px;\n    width: ").concat($width, "px;\n    min-height: 100px;\n    max-height: ").concat($maxHeight, "px;\n    background-color: white;\n    z-index: 1;\n    border-radius: ").concat($alignRight ? "20px 0px 20px 20px" : "0px 20px 20px 20px", ";\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    border: 1px solid ").concat(theme.palette.background.line, ";\n    overflow: auto;\n    padding: 24px 24px 48px 24px;\n  ");
});
const PopupSelect = (param)=>{
    let { placeholder , selectedText , modalContent , onOpen , closeModalOnInnerClick , fullWidth  } = param;
    const [modal, setModal] = (0,react.useState)({
        open: false
    });
    const onSelectClick = (e)=>{
        var _e_target_getBoundingClientRect, _e_target_getBoundingClientRect1;
        const top = e.target.clientHeight - 2;
        const width = window.innerWidth < 768 ? Math.floor(window.innerWidth * 0.9) : Math.floor(window.innerWidth * 0.4);
        const modalRectTop = ((_e_target_getBoundingClientRect = e.target.getBoundingClientRect()) === null || _e_target_getBoundingClientRect === void 0 ? void 0 : _e_target_getBoundingClientRect.top) + e.target.clientHeight - 2;
        const maxHeight = (0,max/* default */.Z)([
            window.innerHeight - modalRectTop,
            250
        ]);
        const modalRectLeft = (_e_target_getBoundingClientRect1 = e.target.getBoundingClientRect()) === null || _e_target_getBoundingClientRect1 === void 0 ? void 0 : _e_target_getBoundingClientRect1.left;
        const alignRight = modalRectLeft + width > window.innerWidth;
        const left = alignRight ? "unset" : 0;
        const right = alignRight ? 0 : "unset";
        setModal({
            open: !modal.open,
            top,
            left,
            right,
            width,
            maxHeight,
            alignRight
        });
        if (!modal.open && onOpen) {
            onOpen();
        }
    };
    const onFilterChange = (filters)=>{
        setModal({
            open: false
        });
        setFilters(filters);
    };
    const onModalClick = ()=>{
        if (closeModalOnInnerClick) {
            setModal({
                open: false
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
        onClickAway: ()=>setModal({
                open: false
            }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            position: "relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                fullWidth: fullWidth,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        open: false,
                        value: !!selectedText || "",
                        native: false,
                        size: "large",
                        displayEmpty: true,
                        onClick: onSelectClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: "",
                                children: placeholder
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: true,
                                children: selectedText
                            })
                        ]
                    }),
                    modal.open && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupSelect_Modal, {
                        $top: modal.top,
                        $left: modal.left,
                        $right: modal.right,
                        $alignRight: modal.alignRight,
                        $width: modal.width,
                        $maxHeight: modal.maxHeight,
                        onClick: onModalClick,
                        children: modalContent
                    })
                ]
            })
        })
    });
};
PopupSelect.defaultProps = {
    placeholder: "",
    selectedText: "",
    closeModalOnInnerClick: true
};
/* harmony default export */ var common_PopupSelect = (PopupSelect);

;// CONCATENATED MODULE: ./components/pages/Album/Index/TagPopupSelect.js





const TagPopupSelect = (param)=>{
    let { category , filters , setFilters  } = param;
    var _category_tags;
    const selected = category === null || category === void 0 ? void 0 : (_category_tags = category.tags) === null || _category_tags === void 0 ? void 0 : _category_tags.find((tag)=>{
        return filters === null || filters === void 0 ? void 0 : filters.find((filterUrlId)=>filterUrlId === tag.urlId);
    });
    const onFilterChange = (filters)=>{
        setFilters(filters);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_PopupSelect, {
        placeholder: category === null || category === void 0 ? void 0 : category.name,
        selectedText: selected === null || selected === void 0 ? void 0 : selected.name,
        modalContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        fontWeight: "fontWeightBold",
                        pb: 6,
                        children: category.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_TagList, {
                    category: category,
                    filters: filters,
                    onChange: onFilterChange,
                    defaultCollapse: false
                })
            ]
        })
    });
};
/* harmony default export */ var Index_TagPopupSelect = (TagPopupSelect);

// EXTERNAL MODULE: ./components/common/ScrollableWrapper/index.js
var ScrollableWrapper = __webpack_require__(28086);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
;// CONCATENATED MODULE: ./components/pages/Album/Index/index.js

function Index_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Index_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 236px;\n  max-width: 100%;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
































const DynamicAlbumContent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6760), __webpack_require__.e(2334), __webpack_require__.e(8581)]).then(__webpack_require__.bind(__webpack_require__, 22334)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(22334)
            ]
    }
});
const NUMBER_PER_PAGE = 30;
const DEFAULT_SORT = "-sort -createdTime";
const FilterButton = (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z)(Index_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    & {\n      justify-content: flex-start;\n      display: inline-block;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      font-weight: ".concat(theme.typography.fontWeightRegular, ";\n    }\n  ");
});
const Img = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject1());
const AlbumIndex = (param)=>{
    let { isMobile , fallbackData  } = param;
    var _router_query, _router_query1;
    const [searchText, setSearchText] = (0,react.useState)((fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.searchText) || "");
    const [order, setOrder] = (0,react.useState)(DEFAULT_SORT);
    const [filters, setFilters] = (0,react.useState)((fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.filters) || []);
    const [page, setPage] = (0,react.useState)((fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.page) || 1);
    const onRemoveFilters = ()=>{
        setFilters([]);
        setPage(1);
    };
    const onFilterChange = (newFilters)=>{
        setFilters(newFilters);
        setPage(1);
    };
    const router = (0,next_router.useRouter)();
    const venderId = (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.venderId;
    // 讓query string跟著頁碼變動
    (0,react.useEffect)(()=>{
        var _window_location_href_split;
        const qs = ((_window_location_href_split = window.location.href.split("?")) === null || _window_location_href_split === void 0 ? void 0 : _window_location_href_split[1]) || "";
        const pageInQs = qs.split("&").filter((string)=>/^page=/.test(string)).map((string)=>string.split("=")[1] || "").shift();
        if (parseInt(pageInQs) !== page) {
            const newQs = qs.split("&").filter((string)=>string && !/^page=/.test(string)).concat([
                "page=".concat(page)
            ]).join("&");
            window.history.replaceState(window.history.state, "", "?".concat(newQs));
        }
    }, [
        page
    ]);
    // 讓query string跟著篩選變動
    (0,react.useEffect)(()=>{
        var _window_location_href_split;
        const qs = ((_window_location_href_split = window.location.href.split("?")) === null || _window_location_href_split === void 0 ? void 0 : _window_location_href_split[1]) || "";
        const tagsInQs = qs.split("&").filter((string)=>/^tag=/.test(string)).map((string)=>string.split("=")[1] || "");
        const matchTags = (0,intersection/* default */.Z)(filters, tagsInQs);
        if ((matchTags === null || matchTags === void 0 ? void 0 : matchTags.length) !== (filters === null || filters === void 0 ? void 0 : filters.length) || (matchTags === null || matchTags === void 0 ? void 0 : matchTags.length) !== (tagsInQs === null || tagsInQs === void 0 ? void 0 : tagsInQs.length)) {
            const tagQsArray = filters.map((filter)=>"tag=".concat(filter));
            const newQs = qs.split("&").filter((string)=>string && !/^tag=/.test(string)).concat(tagQsArray).join("&");
            window.history.replaceState(window.history.state, "", "?".concat(newQs));
        }
    }, [
        filters
    ]);
    // 當query變動時，檢查是否需要調整篩選條件
    (0,react.useEffect)(()=>{
        if (router.isReady) {
            var _router_query, _router_query1;
            const tagsFromQuery = typeof ((_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.tag) === "string" ? [
                router.query.tag
            ] : ((_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.tag) || [];
            const matchedFilters = (0,intersection/* default */.Z)(tagsFromQuery, filters);
            const matchedLength = matchedFilters === null || matchedFilters === void 0 ? void 0 : matchedFilters.length;
            if (matchedLength !== (filters === null || filters === void 0 ? void 0 : filters.length) || matchedLength !== (tagsFromQuery === null || tagsFromQuery === void 0 ? void 0 : tagsFromQuery.length)) {
                setFilters(tagsFromQuery);
            }
        }
    }, [
        router.isReady,
        (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.tag
    ]);
    // 當fallbackData.searchText變化時表示發生page route，
    // 此時將頁碼設回1
    (0,react.useEffect)(()=>{
        if ((fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.searchText) !== searchText) {
            setSearchText(fallbackData.searchText);
            setPage(1);
        }
    }, [
        fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.searchText
    ]);
    // 頁碼變動時判斷點擊換頁，scroll至節點頂部
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            var _containerRef_current;
            return containerRef.current && ((_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollTo({
                top: 0,
                behavior: "smooth"
            }));
        }, 0);
    }, [
        page
    ]);
    const { data: tagCategories  } = (0,usePhotoClassifications/* usePhotoClassifications */.M)({}, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.photoClassifications
    });
    const { data: paginatedAlbums , isLoading: isPaginatedAlbumsLoading  } = (0,useAlbums/* useAlbums */.L)(()=>{
        if (isMobile) {
            return null;
        }
        const query = {
            skip: (0,max/* default */.Z)([
                page - 1,
                0
            ]) * NUMBER_PER_PAGE,
            limit: NUMBER_PER_PAGE,
            sorts: order.split(" ")
        };
        if (venderId) {
            query.venderId = venderId;
        }
        if (searchText) {
            return {
                ...query,
                search: searchText
            };
        }
        return (filters === null || filters === void 0 ? void 0 : filters.length) ? {
            ...query,
            tagUrlIds: filters
        } : query;
    }, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.albums
    });
    const { data: albumCount  } = (0,useAlbumCount/* useAlbumCount */.i)(()=>{
        if (isMobile) {
            return null;
        }
        const query = {};
        if (venderId) {
            query.venderId = venderId;
        }
        if (searchText) {
            return {
                ...query,
                search: searchText
            };
        }
        return (filters === null || filters === void 0 ? void 0 : filters.length) ? {
            ...query,
            tagUrlIds: filters
        } : query;
    }, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.albumCount
    });
    const { data: infiniteAlbums , isLoading: isInfiniteAlbumsLoading , size , setSize  } = (0,useInfiniteAlbums/* useInfiniteAlbums */.$)(()=>{
        if (!isMobile) {
            return null;
        }
        const query = {
            sorts: order.split(" "),
            limit: NUMBER_PER_PAGE
        };
        if (venderId) {
            query.venderId = venderId;
        }
        if (searchText) {
            return {
                ...query,
                search: searchText
            };
        }
        return (filters === null || filters === void 0 ? void 0 : filters.length) ? {
            ...query,
            tagUrlIds: filters
        } : query;
    }, {
        fallbackData: [
            fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.albums
        ]
    });
    const isAlbumsLoading = isPaginatedAlbumsLoading || isInfiniteAlbumsLoading;
    const albums = (0,flatten/* default */.Z)(isMobile ? infiniteAlbums : paginatedAlbums);
    const onLoadMore = ()=>setSize(size + 1);
    const { data: photoTags  } = (0,usePhotoTags/* usePhotoTags */.F)(()=>searchText ? {
            tagName: searchText
        } : null, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.photoTags
    });
    const [filterModal, setFilterModal] = (0,react.useState)({
        open: false
    });
    const openFilterModal = ()=>setFilterModal({
            open: true
        });
    const closeFilterModal = ()=>setFilterModal({
            open: false
        });
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const invokeNativeHeaderControls = ()=>{
        try {
            (0,native_notifier/* enableNativeHeaderMainTabs */.QL)(true);
            (0,native_notifier/* enableNativeHeaderNavBack */.Gz)(false);
            (0,native_notifier/* enableNativeHeaderSearch */.PP)(true);
        } catch (err) {
            console.error("native notifier error: ", err.message);
        }
    };
    (0,react.useEffect)(()=>{
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
            invokeNativeHeaderControls();
        }
    }, [
        webview
    ]);
    // album content modal
    const { albumModal , closeAlbumModal , onAlbumClick , onAlbumContentClose  } = (0,hooks/* useAlbumModal */.Xh)("/album", router, {
        webview,
        nativeHeaderHandler: invokeNativeHeaderControls
    });
    const containerRef = (0,react.useRef)(null);
    const onAlbumTagClick = (tag)=>{
        if ((filters === null || filters === void 0 ? void 0 : filters.length) < 2) {
            router.push("/album?tag=".concat(tag.urlId));
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                var _containerRef_current;
                (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollTo(0, 0);
            }
        } else {
            setFiltersChangeModal({
                open: true,
                tag
            });
        }
    };
    const [filtersChangeModal, setFiltersChangeModal] = (0,react.useState)({
        open: false
    });
    const onFiltersChangeModalConfirm = (tag)=>{
        router.push("/album?tag=".concat(tag.urlId));
        setFiltersChangeModal({
            open: false
        });
    };
    const containerId = "scrollable-album-container";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        stickyHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
        fixContentHeight: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableWrapper/* default */.Z, {
                height: "100",
                overflow: "hidden",
                containerId: containerId,
                wrapperRef: containerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
                        children: [
                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: "flex",
                                        flexWrap: "nowrap",
                                        alignItems: "center",
                                        overflow: "hidden",
                                        my: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                mr: 3,
                                                whiteSpace: "nowrap",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    color: "textSecondary",
                                                    children: "篩選"
                                                })
                                            }),
                                            (filters === null || filters === void 0 ? void 0 : filters.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        mr: 3,
                                                        overflow: "hidden",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton, {
                                                            variant: "outlined",
                                                            size: "small",
                                                            fullWidth: true,
                                                            onClick: openFilterModal,
                                                            children: getFiltersNameString(tagCategories, filters)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        variant: "outlined",
                                                        size: "small",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            color: "error",
                                                            onClick: onRemoveFilters,
                                                            children: "刪除"
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                display: "flex",
                                                flexWrap: "wrap",
                                                height: "45px",
                                                children: tagCategories === null || tagCategories === void 0 ? void 0 : tagCategories.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        mr: 3,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            variant: "outlined",
                                                            size: "small",
                                                            onClick: openFilterModal,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                children: category.name
                                                            })
                                                        })
                                                    }, category._id))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mb: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_SortSelect, {
                                            color: isMobile ? "text" : "primary",
                                            value: order,
                                            onChange: (e)=>setOrder(e.target.value)
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                my: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        container: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                container: true,
                                                item: true,
                                                xs: 9,
                                                spacing: 3,
                                                alignItems: "center",
                                                children: !!searchText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    width: "100%",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NowrapDiv/* default */.Z, {
                                                            children: [
                                                                "搜尋內容：",
                                                                searchText
                                                            ]
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            item: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                color: "textSecondary",
                                                                children: "篩選"
                                                            })
                                                        }),
                                                        tagCategories === null || tagCategories === void 0 ? void 0 : tagCategories.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                item: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_TagPopupSelect, {
                                                                    category: category,
                                                                    filters: filters,
                                                                    setFilters: onFilterChange
                                                                })
                                                            }, category._id)),
                                                        !!(filters === null || filters === void 0 ? void 0 : filters.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            item: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                color: "error",
                                                                sx: {
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: onRemoveFilters,
                                                                children: "清除條件"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 3,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_SortSelect, {
                                                        color: isMobile ? "text" : "primary",
                                                        value: order,
                                                        onChange: (e)=>setOrder(e.target.value)
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        display: "flex",
                                        mt: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                flexGrow: 1,
                                                children: (!!(filters === null || filters === void 0 ? void 0 : filters.length) || !!searchText) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: [
                                                        "共篩出",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "h6",
                                                            component: "span",
                                                            color: "primary",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                component: "span",
                                                                fontWeight: "fontWeightBold",
                                                                children: " ".concat(albumCount !== null && albumCount !== void 0 ? albumCount : "", " ")
                                                            })
                                                        }),
                                                        "個相簿"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                    page: page,
                                                    setPage: setPage,
                                                    pageAmount: Math.floor(albumCount / NUMBER_PER_PAGE) + 1,
                                                    urlPath: constants/* LS_APP_DOMAIN */._8 + "/album"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isAlbumsLoading && !(albums === null || albums === void 0 ? void 0 : albums.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                mt: 25,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                                        src: "/img/default-search-off.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        mt: 5,
                                        mb: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h6",
                                            children: "空的，沒搜尋到任何東西！"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        color: "text.secondary",
                                        children: !!(filters === null || filters === void 0 ? void 0 : filters.length) ? "請重新設定標籤" : "請重新輸入關鍵字"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                dataLength: (albums === null || albums === void 0 ? void 0 : albums.length) || 0,
                                hasMore: true,
                                next: onLoadMore,
                                scrollableTarget: containerId,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    overflow: "hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        container: true,
                                        spacing: isMobile ? 2 : 6,
                                        children: albums === null || albums === void 0 ? void 0 : albums.map((album)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 6,
                                                lg: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumListItem/* default */.Z, {
                                                    album: album,
                                                    onClick: (event)=>{
                                                        if (album) {
                                                            var _album_vender;
                                                            GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                                                                event: "living_action",
                                                                living_event_name: "booking_service_photoalbum",
                                                                living_click_name: album === null || album === void 0 ? void 0 : album.name,
                                                                living_click_location: "相簿圖輯列表頁",
                                                                living_vender: album === null || album === void 0 ? void 0 : (_album_vender = album.vender) === null || _album_vender === void 0 ? void 0 : _album_vender.name,
                                                                living_click_photoalbum_id: album === null || album === void 0 ? void 0 : album._id
                                                            });
                                                        }
                                                        onAlbumClick(event, album);
                                                    },
                                                    onAlbumTagClick: onAlbumTagClick
                                                })
                                            }, album._id);
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        justifyContent: "center",
                        mt: 6,
                        mb: 14,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                            page: page,
                            setPage: setPage,
                            pageAmount: Math.floor(albumCount / NUMBER_PER_PAGE) + 1
                        })
                    }),
                    (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_FilterModal, {
                open: filterModal.open,
                onClose: closeFilterModal,
                onConfirm: onFilterChange,
                defaultFilters: filters,
                tagCategories: tagCategories
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_FiltersChangeModal, {
                open: filtersChangeModal.open,
                onClose: ()=>setFiltersChangeModal({
                        open: false
                    }),
                onConfirm: onFiltersChangeModalConfirm,
                originFilters: filters,
                tag: filtersChangeModal.tag,
                tagCategories: tagCategories
            }),
            (router === null || router === void 0 ? void 0 : router.isReady) && albumModal.open && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* FullscreenModal */.OW, {
                open: albumModal.open,
                onClose: closeAlbumModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAlbumContent, {
                    onClose: onAlbumContentClose,
                    closeModal: closeAlbumModal,
                    fallbackData: albumModal.fallbackData
                })
            })
        ]
    });
};
/* harmony default export */ var Index = (AlbumIndex);


/***/ }),

/***/ 61908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useAlbumCount; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useAlbumCount = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/albums/count?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)({
                ...propsObject,
                limit: 30
            }));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ }),

/***/ 55108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useAlbums; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useAlbums = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/albums?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)({
                ...propsObject,
                limit: 30
            }));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ }),

/***/ 10920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useInfiniteAlbums; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useInfiniteAlbums = (props, swrOptions)=>{
    const getAlbumsKey = (opts)=>(pageIndex, previousPageData)=>{
            const propsObject = typeof opts === "function" ? opts() : opts;
            if (propsObject === null) {
                return null;
            }
            if (previousPageData && !previousPageData.length) {
                return null;
            }
            const limit = propsObject.limit || 30;
            const params = {
                ...propsObject,
                limit: limit,
                skip: pageIndex * limit
            };
            return "/albums?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(params));
        };
    const { data , ...rest } = (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWRInfinite */ .KU)(getAlbumsKey(props), swrOptions);
    // data會無預期出現數字，不確定為什麼，
    // 先避免直接回傳錯誤的資料類型
    return {
        data: typeof data === "number" ? [] : data,
        ...rest
    };
};


/***/ }),

/***/ 57874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ usePhotoClassifications; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const usePhotoClassifications = (props, swrOptions)=>{
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)("/photoClassifications?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(props)), swrOptions);
};


/***/ }),

/***/ 82688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ usePhotoTags; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const usePhotoTags = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/photoTags?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(propsObject));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ }),

/***/ 13946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xh": function() { return /* binding */ useAlbumModal; },
/* harmony export */   "_S": function() { return /* binding */ usePreselectVenderManagement; },
/* harmony export */   "cB": function() { return /* binding */ useGetYearForFooter; },
/* harmony export */   "h3": function() { return /* binding */ useImageLoaded; },
/* harmony export */   "hq": function() { return /* binding */ useConfirmModalHandler; },
/* harmony export */   "o4": function() { return /* binding */ useDateTypeText; },
/* harmony export */   "zi": function() { return /* binding */ useShowScrollToTopButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89289);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79697);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39705);
/* harmony import */ var store_cache_cacheSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24363);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62097);








const useDateTypeText = (services, serviceIds)=>{
    const [dateTypeText, setDateTypeText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("施作");
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(services)) {
            const selectedNonStandardService = services.some((service)=>(serviceIds || []).includes(service._id) && !service.isStandard);
            setDateTypeText(selectedNonStandardService ? "估價" : "施作");
        }
    }, [
        services,
        serviceIds
    ]);
    return dateTypeText;
};
const confirmModelInit = {
    open: false,
    onPositiveClick: ()=>{},
    onNegativeClick: ()=>{},
    positiveButtonText: null,
    negativeButtonText: null,
    title: "",
    message: ""
};
const useConfirmModalHandler = ()=>{
    const [confirmModelConfig, setConfirmModelConfig] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(confirmModelInit);
    const close = ()=>{
        setConfirmModelConfig({
            ...confirmModelInit
        });
    };
    const open = (config)=>{
        setConfirmModelConfig({
            ...confirmModelInit,
            onNegativeClick: close,
            open: true,
            ...config
        });
    };
    return [
        confirmModelConfig,
        open,
        close
    ];
};
const useAlbumModal = (pathname, router, options)=>{
    const { webview , nativeHeaderHandler  } = options;
    const [albumModal, setAlbumModal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        open: false
    });
    const closeAlbumModal = ()=>setAlbumModal({
            open: false
        });
    const onAlbumClick = (e, album)=>{
        var _album_urlId, _album_urlId_toLowerCase, _window_location_href_split;
        e.stopPropagation();
        e.preventDefault();
        if (!album) {
            throw new Error("useAlbumModal: album is undefined");
        }
        const albumUrlId = (_album_urlId_toLowerCase = (_album_urlId = album.urlId).toLowerCase) === null || _album_urlId_toLowerCase === void 0 ? void 0 : _album_urlId_toLowerCase.call(_album_urlId);
        const state = {
            ...window.history.state,
            url: "/album/".concat(albumUrlId),
            as: "/album/".concat(albumUrlId),
            idx: window.history.state.idx + 1
        };
        const photo = (album === null || album === void 0 ? void 0 : album.representativePhoto) || (album === null || album === void 0 ? void 0 : album.frontCover);
        const photoUrlId = photo === null || photo === void 0 ? void 0 : photo.urlId;
        const qs = ((_window_location_href_split = window.location.href.split("?")) === null || _window_location_href_split === void 0 ? void 0 : _window_location_href_split[1]) || "";
        const newQs = qs.split("&").filter((string)=>string && !/^(utm_|page=|tag=)/.test(string)).concat([
            "photoId=".concat(photoUrlId)
        ]).join("&");
        window.history.pushState(state, "", "/album/".concat(albumUrlId, "?").concat(newQs));
        router.query.albumUrlId = albumUrlId;
        router.query.photoId = photoUrlId;
        setAlbumModal({
            open: true,
            fallbackData: {
                photoUrlId: photoUrlId
            }
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handlePopState = ()=>{
            if (location.pathname === pathname && albumModal.open) {
                setAlbumModal({
                    open: false
                });
                if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp" && nativeHeaderHandler) {
                    nativeHeaderHandler();
                }
            }
        };
        window.addEventListener("popstate", handlePopState);
        return ()=>{
            window.removeEventListener("popstate", handlePopState);
        };
    }, [
        albumModal
    ]);
    const onAlbumContentClose = ()=>{
        router.back();
        closeAlbumModal();
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp" && nativeHeaderHandler) {
            nativeHeaderHandler();
        }
    };
    return {
        albumModal,
        closeAlbumModal,
        onAlbumClick,
        onAlbumContentClose
    };
};
const usePreselectVenderManagement = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const [nextRoute, setNextRoute] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    // 當跳轉到非下訂流程時，移除preselectVender
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const onRouteChangeStart = (url, param)=>{
            let { shallow  } = param;
            if (shallow) {
                return;
            }
            const qs = url.split("?")[1] || "";
            const hasPreselectVender = qs.split("&").some((str)=>/^preselect_vender=/.test(str));
            if (!hasPreselectVender) {
                return;
            }
            if (!/^(\/service\/|\/login)/.test(url)) {
                const newQs = qs.split("&").filter((str)=>!/^preselect_vender=/.test(str)).join("&");
                dispatch((0,store_cache_cacheSlice__WEBPACK_IMPORTED_MODULE_3__/* .clearPreselectVender */ .mT)());
                setNextRoute(url.split("?")[0] + (newQs ? "?" + newQs : ""));
                router.events.emit("routeChangeError");
                throw "route change aborted";
            }
        };
        if (nextRoute) {
            router.push(nextRoute);
        }
        router.events.on("routeChangeStart", onRouteChangeStart);
        return ()=>{
            router.events.off("routeChangeStart", onRouteChangeStart);
        };
    }, [
        nextRoute
    ]);
};
const useGetYearForFooter = ()=>{
    const [currentYear, setCurrentYear] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setCurrentYear((0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(), "yyyy"));
    }, []);
    return currentYear;
};
const useShowScrollToTopButton = ()=>{
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const [showButton, setShowButton] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(theme.breakpoints.down("md"));
    const showScrollButton = (e)=>{
        if (isMobile) {
            e.currentTarget.scrollTop > 768 ? setShowButton(true) : setShowButton(false);
        } else {
            e.currentTarget.scrollTop > 800 ? setShowButton(true) : setShowButton(false);
        }
    };
    return {
        showButton,
        showScrollButton
    };
};
const useImageLoaded = ()=>{
    const [isImageLoaded, setIsImageLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const onLoadComplete = ()=>{
        setIsImageLoaded(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (ref.current && ref.current.complete) onLoadComplete();
    }, []);
    return [
        ref,
        isImageLoaded,
        onLoadComplete
    ];
};


/***/ })

}]);